var _a;
import * as SportType from '../../constants/SportType';
import * as ScoreType from '../../constants/ScoreType';
var GENERIC_TWO_PERIODS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod
    ]
};
var GENERIC_THREE_PERIODS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod
    ]
};
var GENERIC_FOUR_PERIODS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod
    ]
};
var GENERIC_FIVE_PERIODS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod
    ]
};
var GENERIC_SEVEN_PERIODS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod,
        ScoreType.SixthPeriod,
        ScoreType.SeventhPeriod
    ]
};
var TENNIS = {
    main: ScoreType.Match,
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod
    ]
};
var GENERIC = {
    main: ScoreType.Match
};
var statsPresentation = (_a = {},
    _a[SportType.TABLE_TENNIS] = GENERIC_SEVEN_PERIODS,
    _a[SportType.VOLLEYBALL] = GENERIC_FIVE_PERIODS,
    _a[SportType.BEACH_VOLLEYBALL] = GENERIC_THREE_PERIODS,
    _a[SportType.FOOTBALL] = GENERIC_TWO_PERIODS,
    _a[SportType.BEACH_FOOTBALL] = GENERIC_THREE_PERIODS,
    _a[SportType.HANDBALL] = GENERIC_TWO_PERIODS,
    _a[SportType.ICE_HOCKEY] = GENERIC_THREE_PERIODS,
    _a[SportType.BASKETBALL] = GENERIC_FOUR_PERIODS,
    _a[SportType.BADMINTON] = GENERIC_THREE_PERIODS,
    _a[SportType.FUTSAL] = GENERIC_THREE_PERIODS,
    _a[SportType.TENNIS] = TENNIS,
    _a[SportType.BOX] = GENERIC,
    _a[SportType.MARTIAL_ARTS] = GENERIC,
    _a[SportType.CYBER_SPORTS] = GENERIC,
    _a[SportType.CYBER_SPORTS_DOTA2] = GENERIC,
    _a[SportType.WATER_POLLO] = GENERIC_FIVE_PERIODS,
    _a[SportType.RUGBY] = GENERIC_TWO_PERIODS,
    _a[SportType.BEACH_VOLLEYBALL] = GENERIC_THREE_PERIODS,
    _a[SportType.FLOORBALL] = GENERIC,
    _a[SportType.SNOOKER] = GENERIC,
    _a[SportType.DARTS] = GENERIC,
    _a[SportType.BANDY] = GENERIC,
    _a[SportType.SWIMMING] = GENERIC,
    _a[SportType.AMERICAN_FOOTBAL] = GENERIC,
    _a[SportType.BASEBALL] = GENERIC,
    _a[SportType.BIATHLON] = GENERIC_FOUR_PERIODS,
    _a);
var MatchScoresAdapter = /** @class */ (function () {
    function MatchScoresAdapter() {
    }
    MatchScoresAdapter.getMainScore = function (sportId, matchScoreIds, scores) {
        var map = statsPresentation[sportId];
        if (map === undefined) {
            return undefined;
        }
        if (!map.hasOwnProperty('main')) {
            return undefined;
        }
        var mainScoreId = matchScoreIds.get(map.main);
        if (mainScoreId === undefined || mainScoreId === null) {
            return undefined;
        }
        var mainScore = scores.get(mainScoreId);
        if (mainScore && mainScore.get('score1') !== undefined && mainScore.get('score1') !== null &&
            mainScore.get('score2') !== undefined && mainScore.get('score2') !== null) {
            return mainScore;
        }
        return undefined;
    };
    MatchScoresAdapter.getAdditionalScores = function (sportId, scores) {
        var result = [];
        if (!statsPresentation.hasOwnProperty(sportId)) {
            return result;
        }
        var map = statsPresentation[sportId];
        if (!map.hasOwnProperty('additional')) {
            return result;
        }
        for (var i = 0; i < map.additional.length; i++) {
            var type = map.additional[i];
            var score = scores.getIn([type]);
            if (score && score.get('score1') !== null && score.get('score1') !== undefined &&
                score.get('score2') !== null && score.get('score2') !== undefined) {
                result[i] = score.get('id');
            }
        }
        return result;
    };
    return MatchScoresAdapter;
}());
export default MatchScoresAdapter;



// WEBPACK FOOTER //
// ./src/components/adapters/MatchScoresAdapter.js